export const en = {
    'today': 'Today',
    'yesterday': 'Yesterday',
};
